import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Table } from 'reactstrap';

import { Link } from 'react-router-dom';

import {
  LOCATIONS,
} from 'constants/index';

import Loading from 'components/App/Loading';
import CustomerAccountTypeBadge from 'components/App/CustomerAccountTypeBadge';

import styles from './DataTableHistoryCoin.module.scss';

const TABLE_COLUMNS = [
  { head: 'Ngày nhận xu', minWidth: 240 },
  { head: 'Tài khoản nhận xu', minWidth: 240 },
  { head: 'Đơn hàng', minWidth: 160 },
  { head: 'Phân loại hoàn xu', minWidth: 240 },
  { head: 'Số xu được hoàn', minWidth: 240 },
];

const formatCoinAmount = (amount) => {
  if (amount === null || amount === undefined || amount === '') return '';

  const formatted = new Intl.NumberFormat('vi-VN').format(Number(amount));
  return `${formatted} xu`;
};

function DataTableHistoryCoin({ histories, isLoading }) {
  return (
    <div className={styles.Component}>
      <Loading loading={isLoading} loaderOnPage />

      {histories.length === 0 && !isLoading ? (
        <div className="NoData">Không có dữ liệu</div>
      ) : (
        <Table responsive className="Table">
          <thead className="Table__Header">
            <tr className="Table__Header__Row">
              {TABLE_COLUMNS.map((column) => (
                <th
                  key={column.head}
                  className="Table__Header__Row__Content"
                  style={{
                    minWidth: `${column.minWidth}px`,
                  }}
                >
                  {column.head}
                </th>
              ))}
            </tr>
          </thead>

          <tbody className="Table__Body">
            {histories.map((item) => (
              <tr className="Table__Body__Row" key={item.id}>
                <td className="Table__Body__Row__Content">
                  <span className="Table__Body__Row__Content__Date">
                    {item.receivedAt}
                  </span>
                </td>

                <td className="Table__Body__Row__Content">
                  <div className="Table__Body__Row__Content__Account">
                    <Link to={`${LOCATIONS.CUSTOMERS}/${item.userId}`} className="Content__Account__Id">{item.accountId}</Link>
                    <div className="d-flex align-items-center">
                      <p className="Content__Account__Name">{item.accountName}</p>
                      <CustomerAccountTypeBadge
                        level={item.memberRank}
                        className="Content__Account__Badge"
                      />
                    </div>
                  </div>
                </td>

                <td className="Table__Body__Row__Content">
                  <Link to={`${LOCATIONS.MANAGER_BOOKING}/${item.bookingId}`} className="Content__Booking__Id">{item.orderId}</Link>
                </td>

                <td className="Table__Body__Row__Content">
                  {item.refundTypeLabel}
                </td>

                <td className="Table__Body__Row__Content">
                  {formatCoinAmount(item.amount)}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}
    </div>
  );
}

DataTableHistoryCoin.propTypes = {
  histories: PropTypes.instanceOf(Array),
  isLoading: PropTypes.bool,
};

DataTableHistoryCoin.defaultProps = {
  histories: [],
  isLoading: false,
};

export default memo(DataTableHistoryCoin);
